export default class DownloadPreviewRequest {
    constructor() {
        this.previewRequestEntries = null;
        this.collectionId = -1;
    }
}